<div class="yalo-apps-wrapper">
  <strong class="body-small">Yalo Apps</strong>
  <div class="divider"></div>

  <a class="yalo-item" href="https://app.yalocobro.com/#/caja-ocupada" target="_blank">
  <!-- <a class="yalo-item" href="https://app.yalocobro.com" target="_blank"> -->
    <div class="yalo-icon">
      <img [src]="'assets/icons/yalo-line.svg'" alt="yalo-line" />
    </div>
    <div class="body-small" style="width: 100%; color: #141414;">Yalo Cobro POS</div>
    <i class="ri-external-link-fill"></i>
  </a>
</div>
